import { Injectable } from "@angular/core";
import { HttpHeaders } from '@angular/common/http';
import { SnackBarService } from "./snack.bar.service";
import { tap } from "rxjs/operators";
import {
    ChangePasswordGQL,
    UserDetailsGQL,
    UpdateProfileGQL,
    NewPasswordCheckGQL,
    NewPasswordCheckMutation,
    NewPasswordGQL,
    AccountNameGQL
} from '../../../generated/graphql';
import { GraphQLError } from "graphql";
import { Observable } from "rxjs";
import { FetchResult } from "apollo-link";
import JSEncrypt from "jsencrypt";
import { environment } from "../../../environments/environment";
import { IsSubscribedToPurchaserAppGQL }  from '../../../generated/graphql';

@Injectable()
export class UserService {
    public UserProfile: any;
    public AccountName: any;
    public PurchaserApp: boolean;

    constructor(
        private accountNameGQL: AccountNameGQL,
        private snackSvc: SnackBarService,
        private changePasswordGQL: ChangePasswordGQL,
        private userDetailsGQL: UserDetailsGQL,
        private updateProfileGQL: UpdateProfileGQL,
        private newPasswordCheckGQL: NewPasswordCheckGQL,
        private newPasswordGQL: NewPasswordGQL,
        private isSubscribedToPurchaserAppGQL: IsSubscribedToPurchaserAppGQL,
    ) {}


    public Init() {
        this.GetProfile();
        this.GetAccountName();
        this.GetPurchaserApp()
    }

    public GetAccountName() {
        this.accountNameGQL.fetch().subscribe(result => {
            this.AccountName = result.data.getAccountName;
        });
    }

    public GetProfile() {
        this.userDetailsGQL.fetch().subscribe(result => {
            this.UserProfile = result.data.profile;
        })
    }

    public ProfileUpdate(value: any) {
        if (!value.Name && !value.Email && !value.Mobile) {
            let err = new Error("Argument null exception");
            console.error(err, value);

            return;
        }

        return this.updateProfileGQL.mutate({
            input: {
                name: value.Name,
                phoneNo: value.Mobile,
                avatar: value.file
            }
        }, {
            context: {
                useMultipart: true
            }
        }).pipe(
            tap(
                () => this.snackSvc.show("Profile updated successfully.", null, { duration: 2000 }
                ), (err) => {
                    this.snackSvc.show(err.message.split(":")[2] || "Failed to update profile.");
                }
            )
        );
    }

    public ChangePassword(value: any) {
        if (!value.CurrentPassword && !value.NewPassword && !value.ConfirmPassword) {
            let err = new Error("Argument null exception");
            console.error(err, value);
            return;
        }

        return this.changePasswordGQL.mutate({
            input: {
                oldPassword:  this.PasswordEncrypt(value.CurrentPassword),
                newPassword:  this.PasswordEncrypt(value.NewPassword),
                confirmPassword:  this.PasswordEncrypt(value.ConfirmPassword)
            }
        }).pipe(
            tap(
                () => {
                    this.snackSvc.show('Password Changed!', null, { duration: 2000 });
                }, (err: GraphQLError) => {
                    this.snackSvc.show(err.message.split(":")[1] || "Failed to change password.");
                }
            )
        );
    }


    public VerifyNewPasswordState(queryParam: string): Observable<FetchResult<NewPasswordCheckMutation, Record<string, any>, Record<string, any>>> {
        return this.newPasswordCheckGQL.mutate(null, {
            context: {
                headers: new HttpHeaders().set('Authorization', `Bearer ${queryParam}`)
            }
        });
    }

    public PasswordEncrypt(password: string): string {
        let jsEncrypt = new JSEncrypt();
        jsEncrypt.setPublicKey(environment.PasswordPublicKey);
        return jsEncrypt.encrypt(password);
      }

    public SetNewPassword(value: any) {

        if (!value.QueryParam && !value.NewPassword && !value.ConfirmPassword) {
            let err = new Error('Argument null exception');
            console.error(err, value);
            return;
        }

        return this.newPasswordGQL.mutate({
            newPassword: this.PasswordEncrypt(value.NewPassword),
            confirmPassword: this.PasswordEncrypt( value.ConfirmPassword)
        }, {
            context: {
                headers: new HttpHeaders().set('Authorization', `Bearer ${value.QueryParam}`)
            }
        }).pipe(
            tap(
                () => this.snackSvc.show("Password Set!", null, { duration: 2000 }),
                (err: GraphQLError) => {
                    this.snackSvc.show(err.message.split(":")[1] || "Set password failed.");
                }
            )
        );
    }
    public GetPurchaserApp() {
        this.isSubscribedToPurchaserAppGQL.fetch().subscribe(result => {
            this.PurchaserApp = result.data.isSubscribedToPurchaserApp;
        });
    }
    //#endregion
}